import { useMemo } from 'react';
import * as THREE from 'three';
import { OBB } from 'three/addons/math/OBB.js';

const vec3 = /* @__PURE__ */ new THREE.Vector3();
/**
 * Renders an oriented bounding box.
 * @param center The center of the box.
 * @param size The size (width, height, depth).
 * @param rotation The quaternion to rotate the box (orientation).
 * @param color Line color
 */
export const OrientedBoundingBox: React.FC<{
  box: OBB;
  color?: THREE.ColorRepresentation;
}> = ({ box, color = 'cyan' }) => {
  const geometry = useMemo(() => {
    const size = box.getSize(vec3);
    const geo = new THREE.BoxGeometry(size.x, size.y, size.z);
    const edges = new THREE.EdgesGeometry(geo);
    return edges;
  }, [box]);

  const matrix = useMemo(() => {
    // Get the rotation from a matrix3
    const rotation = new THREE.Quaternion().setFromRotationMatrix(
      new THREE.Matrix4().setFromMatrix3(box.rotation),
    );
    const m = new THREE.Matrix4();
    m.compose(box.center, rotation, new THREE.Vector3(1, 1, 1));
    return m;
  }, [box]);

  return (
    <lineSegments geometry={geometry} matrix={matrix} matrixAutoUpdate={false}>
      <lineBasicMaterial color={color} />
    </lineSegments>
  );
};
